import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ConsoleTabService } from './console-tab.service';

@Injectable({
  providedIn: 'root'
})
export class QuickAddService {

  public currentState = new BehaviorSubject<'closed' | 'client' | 'project' | 'task' | 'event' | 'string'>('closed');
  public refreshData = new Subject<boolean>();
  private data = new BehaviorSubject<any>(undefined);
  private isollapsed = new Subject()
  constructor() {
  }

  public getData() {
    return this.data.value || undefined;
  }

  public openQuickUpdate(type: 'client' | 'project' | 'task' | 'event', data?: any) {
    this.data.next(data);
    this.currentState.next(type);
  }

  public closeQuickAdd() {
    this.data.next(undefined);
    this.currentState.next('closed');
  }

  public openQuickAdd(type: 'client' | 'project' | 'task' | 'event' | 'string') {
    this.currentState.next(type);
  }

  public setCollapsed(v:any){
      this.isollapsed.next(v)
  }

  public getCollapsed(){
        return this.isollapsed
  }

}
